import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import UserIcon from '@mui/icons-material/AccountCircleOutlined'
import LogoutIcon from '@mui/icons-material/Logout'
import useUser from 'commons/hooks/useUser'
import { LOGOUT_ROUTE } from 'commons/constants/app'
import { useLogoutContext } from '../../../../components/LogOut/context'

function UserItem() {
  const { user } = useUser()
  const { isLogoutComponentActive } = useLogoutContext()
  const navigate = useNavigate()
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (isLogoutComponentActive) return
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleLogout = () => {
    handleClose()
    navigate(LOGOUT_ROUTE)
  }

  const content = (
    <>
      <ListItemIcon
        sx={{
          minWidth: 'auto',
          mr: 0.5,
        }}
      >
        <UserIcon fontSize="small" sx={{ color: 'var(--content-inverse)' }} />
      </ListItemIcon>

      <ListItemText
        primary={user.name || 'Nome do Usuário'}
        primaryTypographyProps={{
          variant: 'body2',
          noWrap: true,
          sx: {
            color: 'var(--content-inverse)',
            fontWeight: 500,
          },
        }}
      />
    </>
  )

  return (
    <div>
      {isLogoutComponentActive ? (
        <ListItem
          sx={{
            px: 1,
            py: 0.5,
            width: 'auto',
            cursor: 'default',
          }}
        >
          {content}
        </ListItem>
      ) : (
        <ListItem
          button
          onClick={handleClick}
          sx={{
            px: 1,
            py: 0.5,
            width: 'auto',
            cursor: 'pointer',
          }}
        >
          {content}
        </ListItem>
      )}
      {!isLogoutComponentActive && (
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
          <MenuItem onClick={handleLogout}>
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            Sair
          </MenuItem>
        </Menu>
      )}
    </div>
  )
}

export default UserItem
